/* eslint-disable linebreak-style */
export default [
  'a',
  'abbr',
  'address',
  'area',
  'b',
  'bdo',
  'blockquote',
  'br',
  'button',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'dd',
  'del',
  'dfn',
  'div',
  'dl',
  'dt',
  'em',
  'fieldset',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'iframe',
  'amp-iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'label',
  'legend',
  'li',
  'link',
  'map',
  'menu',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'pre',
  'q',
  's',
  'samp',
  'script',
  'select',
  'small',
  'span',
  'strong',
  'style',
  'sub',
  'sup',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'ul',
  'var',
  'acronym',
  'applet',
  'basefont',
  'base',
  'big',
  'center',
  'dir',
  'font',
  'frame',
  'frameset',
  'noframes',
  'strike',
  'tt',
  'u',
  'xmp',
  'article',
  'aside',
  'embed',
  'figcaption',
  'figure',
  'footer',
  'header',
  'nav',
  'section',
  'wbr',
  'audio',
  'video',
  'canvas',
  'command',
  'source',
  'datagrid',
  'datalist',
  'details',
  'output',
  'progress',
  'rp',
  'rt',
  'ruby',
  'dialog',
  'hgroup',
  'keygen',
  'mark',
  'meter',
  'summary',
  'time',
  'ads', 'track'
];
